import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { createTheme } from "@mui/material";

const useTheme = () => {
  const stateData = useSelector((state) => state.mainReducer);
  const { themeMode } = stateData;

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode,
          primary: {
            main:         "#E82A2A",
            light:        "#FF6B6B",
            dark:         "#C41E1E",
            contrastText: "#ffffff",
          },
          secondary: {
            main:         "#f97316",
            light:        "#fdba74",
            dark:         "#ea580c",
            contrastText: "#ffffff",
          },
          background: {
            default: "#fff5f5",
            paper:   "#ffffff",
          },
          text: {
            primary:   "#111827",
            secondary: "#6a2d2d",
            disabled:  "#cc7a7a",
          },
          divider: "rgba(232,42,42,0.15)",
          success: { main: "#16a34a" },
          info:    { main: "#2563eb" },
          warning: { main: "#ea6c00" },
          error:   { main: "#E82A2A" },
        },
        shape: { borderRadius: 10 },
        typography: {
          fontSize: 13,
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
        },
        components: {
          MuiDialog: {
            defaultProps: { disableEscapeKeyDown: true },
          },
          MuiCard: {
            styleOverrides: {
              root: {
                boxShadow: "0 2px 12px rgba(232,42,42,0.06)",
                border: "1px solid rgba(232,42,42,0.12)",
              },
            },
          },
          MuiPaper: {
            styleOverrides: {
              root: { boxShadow: "0 2px 12px rgba(232,42,42,0.06)" },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: { textTransform: "none", fontWeight: 600 },
            },
          },
          MuiChip: {
            styleOverrides: {
              root: { fontWeight: 600 },
            },
          },
        },
      }),
    [themeMode]
  );

  useEffect(() => {
    const $style = document.createElement("style");
    if (theme) {
      document.head.appendChild($style);
      $style.innerHTML = `
      :root {
        --colorPrimary: ${theme.palette.primary.main};
        --contrastText: ${theme.palette.primary.contrastText};
        --accent-glow: rgba(232,42,42,0.22);
      }`;
    }
  }, [theme]);

  return theme;
};

export default useTheme;
